<template>
  <div class='type_container'>
    <img :class="['1','2'].includes(details.id) ? 'bank_icon' : ['3','4'].includes(details.id) ? 'bank_icon2' : 'bankIcon3'" :src="details.bankIcon" alt="">
    <div class="type_name_box">
      <div class="type_name">
        {{ details.typeName }}
      </div>
      <!-- <div class="tel" v-for="item in details.telList" :key="item">
        <img src="@/assets/images/home/tel_phone.png" alt="">
        <span class="tem_num">{{ item }}</span>
      </div> -->
    </div>
    <div class="tag_list">
      <div class="tag" :class="['1','2'].includes(details.id) ? 'tag_item' : ['3','4'].includes(details.id) ? 'tag_item2' : 'tag_item3'" v-for="item in details.tagList" :key="item.label">
        <div class="label">{{ item.label }}</div>
        <div class="value">{{ item.value }}</div>
      </div>
    </div>
    <div class="tel">
      <img v-if="type === '2'" src="@/assets/temp/tel_phone2.png" alt="">
      <img v-else src="@/assets/temp/tel_phone.png" alt="">
      <div class="tel_labe">业务咨询电话:</div>
      <div :class="['tel_phone', type==='2'?'tel_phone_type2':'']" v-for="item in details.telList" :key="item">{{ item }}</div>
    </div>
    <div class="type_message">
      <div class="message_item" v-for="(item,index) in details.typeMessage" :key="index">
        <div :class="['1','2'].includes(details.id) ? 'index' : ['3','4'].includes(details.id) ? 'index2' : 'index3'">{{ index + 1 }}</div>
        <div class="content">
          <div class="label">{{ item.label }}</div>
          <div class="value" v-html="item.value"></div>
        </div>
      </div>
    </div>
    <div class="close">
      <div class="close_btn" @click="close">关闭</div>
    </div>
    <div class="left_abs">
      <img v-if="type === '2'" src="@/assets/temp/bank-left-type2.png" alt="">
      <img v-else src="@/assets/temp/bank-left.png" alt="">
    </div>
    <div class="right_abs">
      <img v-if="type === '2'" src="@/assets/temp/bank-right-type2.png" alt="">
      <img v-else src="@/assets/temp/bank-right.png" alt="">
    </div>
    <div class="center_abs">
      <img v-if="type === '2'" src="@/assets/temp/bank-center-type2.png" alt="">
      <img v-else src="@/assets/temp/bank-center.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    id: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      bankDetails: [{
        id: '1',
        bankIcon: require('@/assets/temp/bank-ms.png'),
        typeName: '兴农e贷',
        tagList: [
          {
            label: '贷款额度:',
            value: '企业最高贷款额度500万元。自然人最高额度300万元。'
          },
          {
            label: '贷款期限:',
            value: '最长期限3年'
          },
          {
            label: '贷款利率:',
            value: '4.35%'
          }
        ],
        typeMessage: [
          {
            label: '产品信息',
            value: '蒙商银行向从事农林牧渔业生产、加工、制造、流通、服务等经营活动主体发放的经营性信贷业务。'
          },
          {
            label: '还款方式',
            value: '根据客户需要，可灵活设置。'
          },
          {
            label: '担保方式',
            value: '信用、抵押、自然人保证、担保公司担保等多种担保方式。'
          },
          {
            label: '申请条件',
            value: '借款人拥有2年以上从业经验，信用记录良好。'
          },
          {
            label: '所需材料',
            value: '1.借款人及配偶有效身份证及复印件<br/>2.户口本<br/>3.婚姻状况证明材料及复印件<br/>4.银行需要的其他材料'
          }
        ],
        telList: ['0470-2911007', '0470-2911008']
      },
      {
        id: '2',
        bankIcon: require('@/assets/temp/bank-ms.png'),
        typeName: '惠农e贷',
        tagList: [
          {
            label: '贷款额度:',
            value: '最高贷款额度30万元。信用最高额度10万元。'
          },
          {
            label: '贷款期限:',
            value: '最长期限3年'
          },
          {
            label: '贷款利率:',
            value: '4.35%'
          }
        ],
        typeMessage: [
          {
            label: '产品信息',
            value: '蒙商银行向符合蒙商银行准入基本条件的农户给予授信的信贷业务。'
          },
          {
            label: '还款方式',
            value: '根据客户需要，可灵活设置。'
          },
          {
            label: '担保方式',
            value: '信用、抵押、自然人保证、担保公司担保等多种担保方式。'
          },
          {
            label: '申请条件',
            value: '借款人从事种植、养殖等经营活动不低于2年，有当地户口或固定住所，信用记录良好。'
          },
          {
            label: '所需材料',
            value: '1.借款人及配偶有效身份证及复印件<br/>2.户口本<br/>3.婚姻状况证明材料及复印件<br/>4.银行需要的其他材料'
          }
        ],
        telList: ['0470-2911007', '0470-2911008']
      },
      {
        id: '3',
        bankIcon: require('@/assets/temp/bank-js2.png'),
        typeName: '裕农快贷抵押贷',
        tagList: [
          {
            label: '贷款额度:',
            value: '0.1万元-100万元'
          },
          {
            label: '贷款期限:',
            value: '12个月'
          },
          {
            label: '贷款利率:',
            value: '3.85%'
          }
        ],
        typeMessage: [
          {
            label: '产品信息',
            value: '实时获知贷款额度，线上办理，自主支用。'
          },
          {
            label: '还款方式',
            value: '随借随还，按实际金额和天数计息。'
          },
          {
            label: '担保方式',
            value: '信用、抵押、自然人保证、担保公司担保等。'
          },
          {
            label: '申请条件',
            value: '18-65周岁之间有完全民事行为能力的中国内地居民（不含港澳台），原则上有本地户口或稳定住所，信用记录良好，在建行开立对私结算账户并完成授权，在农业部门办理农村土地经营权抵押备案。'
          },
          {
            label: '所需材料',
            value: '1.借款人及配偶有效身份证及复印件<br/>2.户口本及长期居住证明<br/>3.婚姻状况证明材料及复印件<br/>4.村委会出具的土地证明<br/>5.银行需要的其他材料'
          }
        ],
        telList: ['18748351231']
      },
      {
        id: '4',
        bankIcon: require('@/assets/temp/bank-js2.png'),
        typeName: '裕农快贷信用版',
        tagList: [
          {
            label: '贷款额度:',
            value: '0.1万元-50万元'
          },
          {
            label: '贷款期限:',
            value: '12-60月'
          },
          {
            label: '贷款利率:',
            value: '4.25%'
          }
        ],
        typeMessage: [
          {
            label: '产品介绍',
            value: '实时获知贷款额度，全流程线上办理，自主支用，纯信用贷款，在贷款额度和期限内可循环使用。'
          },
          {
            label: '还款方式',
            value: '随借随还，按实际金额和天数计息。'
          },
          {
            label: '担保方式',
            value: '信用、抵押、自然人保证、担保公司担保等。'
          },
          {
            label: '申请条件',
            value: '18-60周岁之间有完全民事行为能力的中国公民，原则上有本地户口或稳定住所，信用记录良好，在建行开立对私结算账户并完成授权，实际种植或养殖经营者。'
          },
          {
            label: '所需材料',
            value: '1.借款人及配偶有效身份证及复印件<br/>2.户口本及长期居住证明<br/>3.婚姻状况证明材料及复印件<br/>4.村委会出具的土地证明<br/>5.银行需要的其他材料(如土地台账、土地补贴流水、动物防疫本等)'
          }
        ],
        telList: ['18748351231']
      },
      {
        id: '5',
        bankIcon: require('@/assets/temp/BOC.png'),
        typeName: '种植贷',
        tagList: [
          {
            label: '贷款额度:',
            value: '信用类最高额度10万，贷款额度最高300万'
          },
          {
            label: '贷款期限:',
            value: '最长3年'
          },
          {
            label: '贷款利率:',
            value: '3.45%-4.1%'
          }
        ],
        typeMessage: [
          {
            label: '产品介绍',
            value: '针对自有土地且种植经验满2年的个体农户推出的授信业务。'
          },
          {
            label: '还款方式',
            value: '等额本息/按月付息，到期还本。'
          },
          {
            label: '担保方式',
            value: '信用、担保公司担保。'
          },
          {
            label: '申请条件',
            value: '借款人为具有完全民事行为能力的中华人民共和国公民，借款人年龄不低于18周岁且加贷款期限不高于65周岁，信用状况良好。'
          },
          {
            label: '所需材料',
            value: '身份证、户口本、结婚证，村委会出具的种植情况证明、农机具行驶证、防疫本、营业执照、租地合同、地补卡流水及近一年收入流水等可验证收入证明的材料。'
          }
        ],
        telList: ['0470-4259063', '0470-4250962']
      },
      {
        id: '6',
        bankIcon: require('@/assets/temp/BOC.png'),
        typeName: '商户贷',
        tagList: [
          {
            label: '贷款额度:',
            value: '最高100万'
          },
          {
            label: '贷款期限:',
            value: '最长1年'
          },
          {
            label: '贷款利率:',
            value: '3.05%-3.90%'
          }
        ],
        typeMessage: [
          {
            label: '产品介绍',
            value: '针对民生服务类经营满一年的个体工商户和小微企业主推出的授信业务，小微企业主为经营实体的法人代表。'
          },
          {
            label: '还款方式',
            value: '按月付息，到期还本/随借随还。'
          },
          {
            label: '担保方式',
            value: '信用。'
          },
          {
            label: '申请条件',
            value: '借款人为具有完全民事行为能力的中华人民共和国公民，借款人年龄不低于18周岁且加贷款期限不高于65周岁，信用状况良好。'
          },
          {
            label: '所需材料',
            value: '身份证、户口本、结婚证，营业执照、近一年收入流水等可验证收入证明的材料。'
          }
        ],
        telList: ['0470-4259063', '0470-4250962']
      }],
      details: {}
    };
  },
  watch: {
    id: {
      handler(newVal) {
        this.bankDetails.forEach(res => {
          if(res.id === newVal) {
            this.details = res;
          }
        });
      },
      immediate: true
    }
  },
  methods: {
    close() {
      this.$parent.$parent.close();
    }
  }
};
</script>

<style lang='scss' scoped>
.type_container{
  position: relative;
  margin: 25px auto 60px;
  padding: 30px;
  width: 820px;
  border: 1px solid #EBEBEA;
  border-radius: 3px;
}
.bank_icon{
  width: 150px;
  height: 40px;
}
.bank_icon2{
  width: 190px;
  height: 40px;
}
.bank_icon3{
  width: 120px;
  height: 35px;
}
.type_name{
  color: #000;
  margin: 27px 0 20px;
  font-size: 28px;
  font-family: 'SourceHanSansSC-Heavy';
}
.tag_list{
  display: flex;
  flex-wrap: wrap;
  .tag {
    display: flex;
    margin-right: 20px;
    margin-bottom: 20px;
    padding: 7px 9px;
    font-size: 16px;
    border-radius: 4px;
    .label,.value {
      flex-shrink: 0;
      font-family: 'SourceHanSansSC-Regular';
    }
    .label {
      margin-right: 5px;
    }
  }
  .tag_item{
    color: #1689cd;
    background: rgba($color: #1689cd, $alpha: 0.05);
  }
  .tag_item2 {
    color: #1068b1;
    background: rgba($color: #1068b1, $alpha: 0.05);
  }
  .tag_item3{
    color: #E32606;
    background: rgba($color: #B41922, $alpha: 0.05);
  }
}
.type_message{
  .message_item{
    display: flex;
    margin-bottom: 20px;
    &:last-of-type{
      margin: 0;
    }
  }
  .index{
    margin-right: 7px;
    width: 20px;
    height: 20px;
    background-image: url('~@/assets/temp/index.png');
    background-size: 100% 100%;
    font-size: 14px;
    color: #fff;
    text-align: center;
    line-height: 20px;
  }
  .index2{
    flex-shrink: 0;
    margin-right: 7px;
    width: 20px;
    height: 20px;
    background-image: url('~@/assets/temp/index2.png');
    background-size: 100% 100%;
    font-size: 14px;
    color: #fff;
    text-align: center;
    line-height: 20px;
  }
  .index3{
    flex-shrink: 0;
    margin-right: 7px;
    width: 20px;
    height: 20px;
    background-image: url('~@/assets/temp/index3.png');
    background-size: 100% 100%;
    font-size: 14px;
    color: #fff;
    text-align: center;
    line-height: 20px;
  }
  .content{
    .label,.value{
      font-size: 16px;
    }
    .label {
      margin-bottom: 10px;
      font-weight: bold;
      color: #191B27;
    }
    .value {
      color: #555555;
    }
  }
}
.left_abs,.right_abs,.center_abs{
    position: absolute;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .left_abs{
    left: 0;
    top: 0;
    width: 235px;
    height: 416px;
  }
  .right_abs{
    right: 0;
    bottom: 0;
    width: 722px;
    height: 177px;
  }
  .center_abs{
    top: 50%;
    right: 95px;
    transform: translateY(-100%);
    width: 505px;
    height: 202px;
  }
// 弹窗需求新样式
.type_name_box{
  display: flex;
  align-items: center;
}
.tel{
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #EBEBEA;
  font-family: 'SourceHanSansSC-Regular';
  img{
    width: 20px;
    height: 20px;
  }
  .tel_labe{
    margin-left: 10px;
    font-size: 16px;
    color: #000;
  }
  .tel_phone{
    font-size: 16px;
    color: #1689CD;
    padding: 0 10px;
  }
  .tel_phone_type2 {
    color: #E32606 !important;
  }
  .tel_phone + .tel_phone{
    border-left: 1px solid #EBEBEA;
  }
}
.close{
  display: flex;
  justify-content: center;
  margin-top: 30px;
  .close_btn{
    width: 100px;
    height: 40px;
    border-radius: 4px;
    line-height: 40px;
    text-align: center;
    background-color: #1688CD;
    color: #fff;
    z-index: 10;
    cursor: pointer;
  }
}
</style>
